// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-1be7bb69]{position:relative;z-index:6}.scale-1-5[data-v-1be7bb69]{-webkit-transform:scale(1.5);transform:scale(1.5)}.scale-2[data-v-1be7bb69]{-webkit-transform:scale(2);transform:scale(2)}", ""]);
// Exports
module.exports = exports;
